export default "__VITE_ASSET__ec632891__"